export const pos = {
  "header": {
    "title": "CHUAMKAN POS",
    "switchUser": "Switch User",
    "customerPortal": "Customer Portal",
    "previewPortal": "Preview Portal",
    "shiftOpen": "Shift: OPEN",
    "clockIn": "Clock In"
  },
  "logoutConfirm": {
    "title": "Confirm User Switch",
    "message": "Are you sure you want to log out and return to the PIN screen?",
    "confirmButton": "Yes, Switch User"
  },
  "aiOrder": {
    "title": "Smart Order Entry",
    "description": "Type an order like \"2 Siam Sativa and a Gummy\" and let AI add it to the ticket.",
    "placeholder": "e.g., A Bangkok Kush, two Brownie Bites, and a Grinder",
    "addButton": "Add to Order",
    "parsingButton": "Parsing...",
    "disabled": "This feature is currently disabled.",
    "disabledHint": "To enable it, please add your Gemini API key to the src/firebase.config.ts file.",
    "proFeature": "This is a Pro Feature",
    "proFeatureHint": "Please upgrade to the Pro plan to enable AI-powered order entry.",
    "upgradeButton": "Upgrade Plan"
  },
  "tickets": {
    "title": "Tabs / Held Bills",
    "new": "New Ticket",
    "items": "{{count}} items",
    "total": "Total:",
    "empty": "No open tickets."
  },
  "grid": {
    "outOfStock": "Out of Stock",
    "empty": "No products found in this category."
  },
  "ticket": {
    "emptyCart": "Cannot process payment for an empty cart.",
    "customerLabel": "Patient",
    "addCustomerTitle": "Register New Patient",
    "customerPlaceholder": "Search by name, phone, or ID...",
    "customerError": "Error Loading Patients",
    "customerErrorDetails": "Error loading patient data. Check console for details.",
    "customerEmptySystem": "No patients found in the system.",
    "customerEmptySearch": "No patients found for \"{{term}}\".",
    "noTicketSelected": "No Ticket Selected",
    "ticketNumber": "Ticket #{{id}}",
    "clearButton": "Clear",
    "cartEmpty": "Your cart is empty",
    "cartEmptyHint": "Add items from the grid",
    "selectTicket": "Select a ticket",
    "selectTicketHint": "or create a new one",
    "taxToggleEnable": "Enable Tax",
    "taxToggleDisable": "Disable Tax",
    "prescriptionStatus": "Prescription Status",
    "requestPrescription": "Request Prescription",
    "requestPrescriptionTooltip": "Please assign a patient to this ticket before requesting a prescription.",
    "prescriptionPending": "Waiting for doctor's approval...",
    "prescriptionApproved": "Approved! You can proceed to payment.",
    "prescriptionRejected": "Request rejected. Please remove items.",
    "prescriptionQuota": "Prescription Quota",
    "quotaRemaining": "remaining",
    "quotaExpires": "Expires",
    "chargeButton": "Charge",
    "paymentTitle": "Payment",
    "paymentCash": "Cash",
    "paymentQr": "QR Code"
  },
  "scan": {
    "assignSuccess": "Patient assigned: {{name}}",
    "cardNotFound": "Card UID not found: {{uid}}",
    "noTicket": "Please select a ticket before scanning a card.",
    "assignError": "Could not assign patient: {{error}}",
    "genericError": "Error finding patient: {{error}}"
  },
  "kiosk": {
    "title": "Patient Registration",
    "subtitle": "New Patient Intake (Kiosk)",
    "restoring": "Restoring previous session...",
    "steps": {
        "step1": "1. Verify Identity (ID Card / AI Scan)",
        "step2": "2. Initial Symptom Screening",
        "step3": "3. Doctor Consultation (Video/On-site)",
        "step4": "4. Receive Medical Certificate"
    },
    "welcome": {
        "btn": "Register for Consultation",
        "subtitle": "Click to start intake process"
    },
    "kyc": {
        "title": "Patient Information",
        "stepLabel": "Step 1/4",
        "selectMethod": "Select Input Method",
        "methodCard": "Smart Card Reader",
        "methodCardDesc": "Insert Thai ID Card",
        "methodOcr": "AI Camera Scan",
        "methodOcrDesc": "Scan ID with Camera",
        "methodManual": "Manual Input",
        "methodManualDesc": "Type details manually",
        "statusWaiting": "Waiting for card insertion...",
        "statusReading": "Reading data from chip...",
        "statusConnected": "Reader Connected",
        "statusSimulating": "Simulating Read (Demo)...",
        "statusOcr": "AI Analyzing ID Card...",
        "statusSim": "Simulation Mode",
        "next": "Next",
        "back": "Back"
    },
    "photo": {
        "title": "Face Verification",
        "stepLabel": "Step 2/4",
        "instruction": "Take a straight face photo",
        "retake": "Retake",
        "confirm": "Use this Photo",
        "skip": "Skip (Existing photo available)"
    },
    "symptoms": {
        "title": "Symptom Screening",
        "stepLabel": "Step 3/4",
        "question": "Does the patient have these symptoms? (Select all that apply)",
        "other": "Other:",
        "otherPlaceholder": "Please specify...",
        "consent": "I consent to disclose health info and photos to the clinic for diagnosis (PDPA Consent).",
        "confirm": "Confirm & Queue",
        "processing": "Processing..."
    },
    "waiting": {
        "status": "Connecting to Doctor...",
        "title": "Queued Successfully",
        "message": "Waiting for doctor to accept...",
        "joinCall": "Join Video Call",
        "cancel": "Cancel Queue / Start Over"
    },
    "completed": {
        "title": "Certificate Approved",
        "subtitle": "Medical Certificate Issued",
        "instruction": "Please present this certificate at the pharmacy.",
        "certId": "Certificate ID",
        "approvedBy": "Approved by Dr.",
        "saveImage": "Save to Phone",
        "print": "Print Paper",
        "finish": "Finish / Return Home"
    }
  },
  "sidebar": {
    "sales": "Sales",
    "receipts": "Receipts",
    "shift": "Shift",
    "settings": "Settings",
    "backOffice": "Back Office"
  },
  "settingsModal": {
    "title": "POS Settings",
    "tabs": {
      "general": "General",
      "printer": "Printer",
      "tax": "Tax"
    },
    "general": {
      "title": "General Settings",
      "description": "Configure local device settings for this POS station.",
      "cameraScan": {
        "title": "Enable Camera Barcode Scanning",
        "description": "Use the device's camera to scan product barcodes."
      },
      "darkMode": {
        "title": "Dark Mode",
        "description": "The POS interface is designed for dark mode."
      }
    },
    "printer": {
      "title": "Printer Selection",
      "description": "Select the POS device you are currently using to configure its printer.",
      "empty": "No POS devices found. Please add one in the back office settings.",
      "back": "Back to Device List",
      "titleEdit": "Printer Settings for {{deviceName}}"
    },
    "tax": {
      "title": "Tax Settings",
      "description": "These settings are shared across all POS devices in the store.",
      "enable": "Enable Tax System",
      "taxName": "Tax Name (e.g., VAT)",
      "taxRate": "Tax Rate (%)"
    }
  }
};